import React from "react";
import PropTypes from "prop-types";

const ImageSlide = (props) => {
	const { image, title } = props;

	return (
		<div className="homepage-slider__image-slide">
			<div className="aspect-ratio-box">
				<img src={image.url} alt={image.alt ? image.alt : title} />
			</div>
		</div>
	);
};
export default ImageSlide;

ImageSlide.propTypes = {
	image: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	title: PropTypes.string,
};
